import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/en';
import 'dayjs/locale/cs';
import 'dayjs/locale/nl';

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
